<template>
<div>
<manageDroit :open="openManage" :editItem="editItem" @close="closeAdd"/>
  <v-btn
        v-if="type=='groupe' && datas.addgroup"
        class="ma-2"
        @click="openManage=true">ajouter un groupe</v-btn>
          <v-row dense>
            <v-col class="pa-2 col-12 col-md-6 mx-auto">
                <v-text-field
                outlined
                  v-model="searchList"
                  append-icon="mdi-magnify" label="rechercher" single-line hide-details
                ></v-text-field>
            </v-col>
          </v-row>

  <v-expansion-panels>

    <v-expansion-panel
      v-for="(typeList,i) in filteredList"
      :key="i"
      @click="getCurrentDroit(typeList.id)"
    >
      <v-expansion-panel-header>
        <v-row no-gutters>
          <v-col cols="4">
            <v-icon left v-if="type=='perso'" :class="typeList.revert ? 'red--text' : 'green--text'">
              mdi-account-outline
            </v-icon>
            
            <v-icon left v-if="type=='groupe'" :class="typeList.revert ? 'red--text' : 'green--text'"           
            >
              mdi-account-multiple-outline
            </v-icon>

        <span v-for="index in typeList.niveau" :key="index">            
          <v-icon left class="ma-0">
              mdi-minus
            </v-icon></span>
            <v-icon left class="ma-0">
              mdi-arrow-right-thin
            </v-icon>
        {{typeList.libelle}}

          </v-col>
          <v-col cols="1" v-if="type=='groupe'">
                <v-icon
                
                @click="editItem = JSON.parse(JSON.stringify(typeList)); openManage=true;"
                >mdi-pencil</v-icon>            
          </v-col>
          <v-col cols="7" v-if="type=='groupe'">
          <span class="text-caption" v-if="users && users.length>0">
            <span  v-for="(user,i) in users"
                  :key="i">
                  <span v-if="user.idtype == typeList.id"> {{user.libelle}},</span>
            </span>
          </span>           
          </v-col>
        </v-row>
      </v-expansion-panel-header>

        <v-expansion-panel-content>

                <v-tabs v-model="tab">
                  <!-- début de la boucle des tabulations qui vont permettre l'affichage des noms de core-->
                    <v-tab v-for="(listCore,c) in datas.listElems" :key="c">{{listCore.nameCore}} ({{ listCore.list.length }})</v-tab>
                    <v-tabs-items v-model="tab" class="pa-2">
                        <!-- boucle de l'intérieur des tabulations qui vont permettre l'affichage des options pour les cores-->
                        <v-tab-item v-for="(listCore,c) in datas.listElems" :key="c" >

                          <v-text-field
                            v-model="searchDr[c]"
                            append-icon="mdi-magnify" label="rechercher" single-line hide-details
                          ></v-text-field>  

                          <div v-if="listCore.description" class="font-italic">{{listCore.description}}</div> 
                            <!-- boucle del a liste des options qui font l'objet de modification (actier; hériter etc.)-->
                             
                            <v-col v-for="(liste,d) in filteredItems[c]" :key="d" class="elevation-1" no-gutters >
                              <v-row align="center">
                                <v-col class="col-12 col-md-4">
                                  {{liste.libelle}}
                                  <div v-if="liste.description" class="font-italic">({{liste.description}})</div> 
                                  </v-col>
                              <v-col class="col-12 col-md-6 text-center">

                              <v-btn-toggle>
                                <v-btn 
                                v-for="(listChoice,q) in listCore.choices" :key="q" :value="listChoice.value"
                                @click="changeDroit(liste.id,listChoice.value,listCore.core,typeList.id)"

                                :class="classButton(listChoice,zemodel(typeList,listCore.core,liste.id),getActivState(typeList,listCore,liste.id),listCore,typeList)" 
                                >
                                  <span class="hidden-sm-and-down">{{listChoice.name}}

                                    <span v-if="listChoice.value=='legacy' && zemodel(typeList,listCore.core,liste.id)=='legacy'">({{getActivState(typeList,listCore,liste.id).text}})</span>

                                  </span>

                                  <v-icon right>
                                    {{listChoice.icon}}
                                  </v-icon>
                                </v-btn>
                              </v-btn-toggle>

                              </v-col>

                              <v-col class="col-12 col-md-2 text-center" v-if="liste.related">
                                <v-btn v-for="(action,ac) in liste.related" :key="ac"
                                @click="goToOtherDroit(action)" >
                                  {{action.name}}
                                </v-btn>
                              </v-col>

                              </v-row>
                                                                                          
                            </v-col>
                          

                        </v-tab-item>

                    </v-tabs-items>
                </v-tabs>


        </v-expansion-panel-content>

    </v-expansion-panel>
  </v-expansion-panels>


</div>
</template>

<script>

import _ from "lodash"
import { openRightsEditor } from './navigation'

export default {
    name : 'droitGroupe',
    props : ['datas','type','args','users'],
    components : {
      manageDroit   : () => import('./manageDroit.vue'),
        },
            data: function() {
            return {
                tab : 'd',
                droit : undefined,
                currentDroit : [],
                getDatas : this.datas,
                openManage : false,
                editItem : false,
                searchDr : {},
                searchList : '',
            }
        },

        computed : {

            Datas() {
              return this.datas
            },

            filteredItems() {
              return this.datas.listElems.map((core, c) => {
                const search = (this.searchDr[c] || "").toLowerCase();

                let list = core.list;

                if (search) {
                  list = list.filter(item =>
                    item.libelle.toLowerCase().includes(search)
                  );
                } else {
                  list = list.slice(0, 30); // limite si pas de recherche
                }

                return list;
              });
            },
    
            filteredList() {
              if (!this.searchList) {
                return this.datas.listType;
              }
              const s = this.searchList.toLowerCase();
              return this.datas.listType.filter(item =>
                item.libelle.toLowerCase().includes(s)
              );
            }
        },
        watch : {
            Datas(val) {
              this.getDatas = val;
            },

          searchDr: {
            handler: _.debounce(function () {
              this.$forceUpdate();
            }, 200),
            deep: true
          }
        },

        methods : {


          closeAdd(ifreload) {
            this.openManage = false;
            this.editItem = false;
            if(ifreload) this.$emit('reload')
          },

          changeDroit(item,model,core,idType) {
            this.API({type:'post', url:'engine/droits/apply', params:{core:core,ID:item,value:model,type:this.type,typeID:idType,root:this.args.root}}).then((resp) => {
              if(resp.data.success) {
                this.$toast.success('modifié');
                  
                  this.datas.listType.find((el) => el.id === idType).droits = resp.data.array               

                this.getCurrentDroit(idType)
              } else {
                this.$toast.error(resp.data.message);
              }
            })

          },

          getCurrentDroit(id) {
            this.API({type:'post', url:'engine/droits/getLegacy', params:{type:this.type,id:id,root:this.args.root}}).then((resp) => {
              this.currentDroit = resp.data

            })


          },


          getActivState(typeList,listCore,id) {
            var retour = {text:'',value:''};
             if( this.currentDroit[listCore.core] && this.zemodel(typeList,listCore.core,id)=='legacy') {
              retour.value = this.currentDroit[listCore.core][id]
                if(this.currentDroit[listCore.core][id]==undefined) {
                  retour.text = listCore.choices.find((el) => el.default === typeList.revert).name;
                } else {
                  retour.text = listCore.choices.find((el) => el.value === retour.value).name;
                }

             }
             if(this.zemodel(typeList,listCore.core,id)!='legacy') {
              retour.value = this.zemodel(typeList,listCore.core,id);
                retour.text = listCore.choices.find((el) => el.value === retour.value).name;
             }

             if(!this.currentDroit[listCore.core] && this.zemodel(typeList,listCore.core,id)=='legacy') retour.text = listCore.choices.find((el) => el.default === typeList.revert).name+' par défaut'
          return retour;
          },

          zemodel(Line,core,id) {
            //si un droit est appliqué dans l'item en question, il sera activé ou désactivé.
            // par contre si il n'y a aucun droit sur cet item alors on pren les droits qui en sont hérité, et on met le bouton à "hérité". 
            var retour = 'legacy';
            if(Line.droits[this.args.root]) {

                if(Line.droits[this.args.root] && Line.droits[this.args.root][core] && Line.droits[this.args.root][core][id]!= undefined) {
                retour =  Line.droits[this.args.root][core][id];
                } 

            }

            return retour;
          },

          classButton(listChoice, model,activeState,listCore,typeList) {
            if(listChoice.value=='legacy' && model=='legacy') {
              if(activeState.value==='' || activeState.value==undefined) { return listCore.choices.find((el) => el.default === typeList.revert).class } 
              else {
                return listCore.choices.find((el) => el.value === activeState.value).class
              }
              
            }

            if(model!='legacy' && activeState.value==listChoice.value) {
              return listChoice.class;
            }
          },

          goToOtherDroit(action) {
            openRightsEditor({
              id: action.id,
              target: action.target,
              root: action.root,
            })
          }

        },
        mounted() {
          
        }
}
</script>
